import React from 'react';

import { handleImgError } from '../../constants/index';
import { setCreatedAt, addComma, textSilce } from '../../constants/index';

const ContentsType = ({ data, type, showCompany }) => {
  const typeCheckRender = (_data, _type) => {
    let result;
    let renderData = _data;
    let discountPrice = 0;
    let discont = Number(renderData?.discount);

    if (_type === 'shopping') discountPrice = Number(renderData?.price) * (1 - discont / 100).toFixed(2);
    if (_type === 'program') renderData = renderData?.episode;

    switch (_type) {
      case 'vod':
        result = (
          <section>
            <h1>{renderData?.episodeNo && `${renderData?.episodeNo}화`}</h1>
            <span>{`${renderData?.title}`}</span>
            <p>{renderData?.programTitle && textSilce(renderData?.programTitle, 13)}</p>
          </section>
        );
        break;
      case 'main-vod':
        result = (
          <section>
            <div className='main-vod-contents-box'>
              <img src={renderData?.programImage ? renderData?.programImage : ''} alt='' onError={e => handleImgError(e, 'icon')} />
              <p>{renderData?.programTitle && textSilce(renderData?.programTitle, 13)}</p>
            </div>
          </section>
        );
        break;
      case 'rec-vod':
        result = <section></section>;
        break;
      case 'sub-vod':
        result = (
          <section>
            <h1>{`${textSilce(renderData?.title, 15)}`}</h1>
            <p>
              {renderData?.episodeNo && <b>{`${renderData?.episodeNo}화`}</b>}
              {setCreatedAt(renderData.createdAt)}
            </p>
          </section>
        );
        break;
      case 'program':
        result = (
          <section>
            <h3>{renderData?.episodeNo ? `${renderData?.episodeNo}화` : ''}</h3>
            <h1>{renderData?.title && textSilce(renderData?.title, 15)}</h1>
            {showCompany && <p>{textSilce(renderData?.programTitle, 13)}</p>}
          </section>
        );
        break;
      case 'today-program':
        result = (
          <section>
            <h3>
              {renderData?.episode?.episodeNo && `${renderData?.episode?.episodeNo}화 `}
              {renderData?.program?.title && `${textSilce(renderData?.program?.title, 13)}`}
            </h3>
            <h1>{renderData?.time && renderData?.time}</h1>
          </section>
        );
        break;
      case 'vod-record':
        result = (
          <section>
            <h3>{renderData?.episodeNo ? `${renderData?.episodeNo}화` : ''}</h3>
            <h1>{renderData?.episodeTitle && textSilce(renderData?.episodeTitle, 13)}</h1>
            <p>{renderData?.programTitle && textSilce(renderData?.programTitle, 15)}</p>
          </section>
        );
        break;
      case 'tide':
        result = (
          <section className='tideBox'>
            <h3>{renderData?.title && textSilce(renderData?.title, 13)}</h3>
            <p>{renderData.createdAt && setCreatedAt(renderData.createdAt)}</p>
          </section>
        );
        break;
      case 'shopping':
        result = (
          <section>
            <h1>{textSilce(renderData.name, 15)}</h1>
            <i>{discont !== 0 ? `${discont}% ` : ''}</i>
            <b>
              {discont !== 0
                ? renderData?.price
                  ? `${addComma(discountPrice)}`
                  : ''
                : renderData?.price
                ? `${addComma(renderData.price)}`
                : ''}
            </b>
            {discont !== 0 && <span>{renderData?.price ? `${addComma(renderData.price)} ` : ''}</span>}
          </section>
        );
        break;
      case 'vodDetail':
        result = (
          <section>
            <div>
              <div style={{ display: 'flex' }}>
                <h1>{`
                ${renderData?.episodeNo ? `${renderData?.episodeNo}회` : ''}
                ${textSilce(renderData.title, 15)}
                `}</h1>
              </div>
              <div>
                {<span>{renderData?.broadcastDate ? `${setCreatedAt(renderData?.broadcastDate)}` : ''} 방영</span>}
                <span> | </span>
                {<span>{`${Math.floor(renderData.runTimeMin)}분`}</span>}
              </div>
            </div>
            <div style={{ margin: '15px 0' }}>{renderData.vod && <span className='vodChip'>VOD</span>}</div>
          </section>
        );
        break;
      case 'vodDetailRow':
        result = (
          <section>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '7px' }}>
                <h3>{`
                 ${renderData?.episodeNo ? `${renderData?.episodeNo}회` : ''}
                ${textSilce(renderData.title, 13)}
                `}</h3>
                {renderData.vod && <span className='vodChip'>VOD</span>}
              </div>
              <div>
                {<span>{renderData?.broadcastDate ? `${setCreatedAt(renderData?.broadcastDate)}` : ''} 방영</span>}
                <span> | </span>
                {<span>{`${Math.floor(renderData.runTimeMin)}분`}</span>}
              </div>
            </div>
          </section>
        );
        break;
      case 'vodList':
        result = (
          <section>
            <h1>{textSilce(renderData.title, 13)}</h1>
          </section>
        );
        break;
      case 'contest':
        result = (
          <section>
            <h1>{textSilce(renderData.title, 50)}</h1>
            <span>{`${setCreatedAt(Number(renderData.startDate))} ~ ${setCreatedAt(Number(renderData.endDate))}`}</span>
            {renderData.type === 'end-contest' ? (
              renderData.result ? (
                <nav>결과발표</nav>
              ) : (
                <p>{`${renderData.resultDate} 결과발표`}</p>
              )
            ) : (
              ''
            )}
          </section>
        );
        break;
      case 'search-program':
        result = (
          <section>
            <h1>{`
            ${renderData?.timeInfoCycle ? renderData?.timeInfoCycle : ''} 
            ${renderData?.timeInfoDay ? renderData?.timeInfoDay : ''}
            ${renderData?.startTime ? renderData?.startTime : ''}
            `}</h1>
            <h3>{renderData?.title}</h3>
            <h2>{textSilce(renderData?.desc, 30)}</h2>

            <p>
              PD <b>{renderData?.pd ? renderData?.pd : '-'}</b>
            </p>
            <p>
              출연진 <b>{renderData?.cast ? renderData?.cast : '-'}</b>
            </p>
          </section>
        );
        break;
      case 'search-vod':
        result = (
          <section>
            <h3>{`${renderData?.title} ${renderData?.episodeNo}화`}</h3>
            <h2>{textSilce(renderData?.contents, 15)}</h2>

            <p>
              촬영지 <b>{renderData?.location ? renderData?.location : '-'}</b>
            </p>
            <p>
              출연진 <b>{renderData?.cast ? renderData?.cast : '-'}</b>
            </p>
            <p>
              {renderData?.broadcastDate ? `${setCreatedAt(renderData?.broadcastDate)} 방영 | ` : ''}
              {renderData?.runTimeMin ? `${Math.floor(renderData.runTimeMin)}분` : ''}
            </p>
          </section>
        );
        break;
      case 'search-fishing':
        result = (
          <section>
            <h3>{`${renderData?.title}`}</h3>

            <p>{`${renderData.createdAt && setCreatedAt(renderData.createdAt)} | 조회수 ${renderData?.viewCnt}`}</p>
          </section>
        );
        break;
    }
    return result;
  };

  return (
    <>
      {/* 타입마다 내용 다르게. */}
      {typeCheckRender(data, type)}
    </>
  );
};

export default ContentsType;
